import Integration from './Integration.vue'

export default Integration
